import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Settings from "../../components/logisticsTwo/Settings";
import Header from "../../components/logisticsTwo/Header";
import Sidebar from "../../components/logisticsTwo/Sidebar";
import Footer from "../../components/logisticsTwo/Footer";
import { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import ThemeProvider from "../../hooks/themeProvider";
import PageLoader from "../../components/PageLoader";


const LogisticsLayoutTwo = () => {
	let navigate = useNavigate()
	const dispatch = useAppDispatch()
	const [color, setColor] = useState('universal')
	const handleSettigns = () => {
		dispatch(settings.set({ visible: !visible }))
	}
	const { height, width } = useWindowDimensions();
	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar, theme, isThemeAvailable } = result
	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			dispatch(settings.set({ primary: '#f5e93cac' }))
			dispatch(settings.set({ secondary: '#ffffff' }))

		}
		else if (theme == 'lightmode') {
			dispatch(settings.set({ primary: '#ffffffa2' }))
			dispatch(settings.set({ secondary: '#000000a2' }))
		}
		else if (theme == 'universal') {
			dispatch(settings.set({ primary: '#233C64' }))
			dispatch(settings.set({ secondary: '#ffffff' }))
		}
		else if (theme == 'luxury') {
			dispatch(settings.set({ primary: '#bd238c' }))
			dispatch(settings.set({ secondary: '#ffffff' }))

		}
		else if (theme == 'harmony') {
			dispatch(settings.set({ primary: '#000000a2' }))
			dispatch(settings.set({ secondary: '#000000a2' }))
		}
		else if (theme == 'warmth') {
			dispatch(settings.set({ primary: '#000000a2' }))

		}
		// const data = document.getElementById("layer") as HTMLInputElement;
		// data.setAttribute("fill", "#603812")
		// data.setAttribute("stroke", "#603812")
	}, [theme]);
	useEffect(() => {
		dispatch(settings.set({
			theme: 'universal',
			isThemeAvailable: true,
		}))
	}, [])

	if (!isThemeAvailable) {
		console.log('theme not loaded')
		return (
			<>
				<PageLoader />
			</>
		)
	}
	return (
		<>
			<ThemeProvider>
				{width && width < 720 ?
					<>
						<Outlet />
					</>
					:
					<div className="leading-normal tracking-normal" id="main-body">
						<div className="flex flex-col w-full sm:hide max-h-screen h-screen bg-slate-200">
							{visible ? <Settings /> : <></>}
							<Header />
							<div className="w-full flex flex-row bg-primary">
								<Sidebar />

								<div className={`${sidebar ? `ml-64` : `ml-24 z-0 `} w-full overflow-auto mt-20 bg-slate-200 dark:bg-slate-300`}>

									<Outlet />

								</div>
								<div className="fixed bottom-0 z-[1000] w-full bg-slate-50">
									{footer ? <Footer /> : ""}
								</div>
							</div>
						</div>
					</div>
				}
			</ThemeProvider>
		</>
	)
}
export default LogisticsLayoutTwo;